import SkTechApiClient from "./base/SkTechApiClient";
import { AddGeneralAssignment, Test, TestAttempt, TestLevelSetting, TestPointSetting, UserTestAssignment } from "../stores/TestsStore";


export default class TestAttemptApiClient extends SkTechApiClient {

  public addTestAttempt = async (addTestAttempt: TestAttempt): Promise<TestAttempt> => {
    return await this.Post(`/api/TestAttempt`, addTestAttempt)
      .then((response) => {
        return response;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public getAllByUserId = async (userId: string): Promise<TestAttempt[]> => {
    return await this.Get(`/api/TestAttempt/user/${userId}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public getByIdIncludeAll = async (id: string): Promise<TestAttempt> => {
    return await this.Get(`/api/TestAttempt/${id}`)
      .then(function (response) {
        if (response?.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public updateTestAttempt = async (id: number, testAttempt: TestAttempt): Promise<TestAttempt> => {
    return await this.Put(`/api/TestAttempt/${id}`, testAttempt)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      });
  }
}